import { Link } from 'react-router-dom'
import { useState } from 'react'
import { createPortal } from 'react-dom'

import {
  Plus,
  Ticket,
  Lock,
  Percent,
  CurrencyDollar,
  X,
  Trash,
  Clock,
  CheckCircle,
  ProhibitInset,
} from '@phosphor-icons/react'

import './VouchersPage.scss'

// ─── Data ─────────────────────────────────────────────────────────────────────

const OUTLETS = [
  { id: 1, name: 'KC Kitchen',      address: 'Lot G-12, Suria KLCC, Jalan Ampang',     redeemed: 9 },
  { id: 2, name: 'Pong Pong Cafe',  address: 'Lot 6.09, Level 6, Pavillion KL',         redeemed: 6 },
  { id: 3, name: 'BS Corner',       address: 'No.14, Jalan Telawi 3, Bangsar',          redeemed: 3 },
  { id: 4, name: 'Song Song Corner',address: 'No.8, Jalan Ampang Hilir, KL',            redeemed: 0, excluded: true },
]

const vouchers = [
  {
    id: 1,
    title: '10% off your order',
    voucherName: '10% off your order',
    points: '200 pts',
    pointsNum: 200,
    minimum: 'No min spend',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 18,
    claimed: 18,
    total: 100,
    left: 82,
    revenue: 'RM3,120.00',
    type: 'percent',
    discount: '10% off',
    scope: 'Merchant-wide',
    status: 'active',
  },
  {
    id: 2,
    title: 'RM5 cash voucher',
    voucherName: 'RM5 cash voucher',
    points: '150 pts',
    pointsNum: 150,
    minimum: 'Min RM30.00',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 18,
    claimed: 36,
    total: 50,
    left: 14,
    revenue: 'RM1,080.00',
    type: 'cash',
    discount: 'RM5 off',
    scope: 'Merchant-wide',
    status: 'active',
  },
  {
    id: 3,
    title: 'RM10 off Omakase',
    voucherName: 'RM10 off Omakase',
    points: '200 pts',
    pointsNum: 200,
    minimum: 'No min spend',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 0,
    claimed: 18,
    total: 100,
    left: 82,
    revenue: 'RM1,800.00',
    type: 'percent',
    discount: 'RM10 off',
    scope: 'KLCC Branch, Puchong Branch only',
    status: 'expired',
  },
  {
    id: 4,
    title: 'RM5 cash voucher',
    voucherName: 'RM5 cash voucher',
    points: '150 pts',
    pointsNum: 150,
    minimum: 'Min RM30.00',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 18,
    claimed: 36,
    total: 50,
    left: 14,
    revenue: 'RM1,080.00',
    type: 'cash',
    discount: 'RM5 off',
    scope: 'Merchant-wide',
    status: 'active',
  },
]

const promoCodes = [
  {
    id: 1,
    title: 'SAVE20',
    code: 'SAVE20',
    description: '20% off your order',
    discount: '20% off',
    discountBadge: '20% off',
    minimum: 'No min spend',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 18,
    redeemed: 22,
    total: 100,
    left: 78,
    revenue: 'RM3,120.00',
    type: 'percent',
    scope: 'KLCC Branch, Puchong Branch only',
    status: 'active',
  },
  {
    id: 2,
    title: 'LUNCH5',
    code: 'LUNCH5',
    description: 'RM5 lunch promo',
    discount: 'RM5 off',
    discountBadge: 'RM5 off',
    minimum: 'Min spend RM30',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 18,
    redeemed: 64,
    total: 100,
    left: 36,
    revenue: 'RM1,920.00',
    type: 'cash',
    scope: 'Merchant-wide',
    status: 'active',
  },
  {
    id: 3,
    title: 'RAMEN20',
    code: 'RAMEN20',
    description: '20% off ramen bowls',
    discount: '20% off',
    discountBadge: '20% off',
    minimum: 'No min spend',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 18,
    redeemed: 18,
    total: 50,
    left: 32,
    revenue: 'RM720.00',
    type: 'percent',
    scope: 'Merchant-wide',
    status: 'active',
  },
  {
    id: 4,
    title: 'MATCHA8',
    code: 'MATCHA8',
    description: 'RM8 dessert voucher',
    discount: 'RM8 off',
    discountBadge: 'RM8 off',
    minimum: 'Min spend RM40',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 0,
    redeemed: 22,
    total: 40,
    left: 18,
    revenue: 'RM880.00',
    type: 'cash',
    scope: 'Merchant-wide',
    status: 'expired',
  },
  {
    id: 5,
    title: 'WEEKEND15',
    code: 'WEEKEND15',
    description: 'Weekend dining promo',
    discount: '15% off',
    discountBadge: '15% off',
    minimum: 'Min spend RM80',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 18,
    redeemed: 72,
    total: 120,
    left: 48,
    revenue: 'RM5,040.00',
    type: 'percent',
    scope: 'Merchant-wide',
    status: 'active',
  },
  {
    id: 6,
    title: 'TEPPAN50',
    code: 'TEPPAN50',
    description: 'RM50 off omakase',
    discount: 'RM50 off',
    discountBadge: 'RM50 off',
    minimum: 'Min spend RM300',
    validity: '01/05/2026 - 31/05/2026',
    validityLong: '1 May - 31 May 2026',
    daysRemaining: 18,
    redeemed: 8,
    total: 20,
    left: 12,
    revenue: 'RM2,400.00',
    type: 'cash',
    scope: 'Merchant-wide',
    status: 'active',
  },
]

// ─── Delete Modal ─────────────────────────────────────────────────────────────

function DeleteModal({ item, kind, onClose, onConfirm }) {
  const isVoucher = kind === 'voucher'
  const label = isVoucher ? item.title : item.code

  return createPortal(
    <div className="vdp-overlay" onClick={onClose}>
      <div className="vdp-delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="vdp-delete-modal__header">
          <h3>Delete {isVoucher ? 'voucher' : 'promo code'}</h3>
          <button className="vdp-delete-modal__close" onClick={onClose}><X size={20} /></button>
        </div>

        <div className="vdp-delete-modal__body">
          <p className="vdp-delete-modal__desc">This action is permanent and cannot be undone.</p>

          <div className="vdp-delete-modal__card">
            <div className="vdp-delete-modal__card-icon">
              {isVoucher
                ? (item.type === 'percent' ? <Percent size={20} /> : <CurrencyDollar size={20} />)
                : <Ticket size={20} />
              }
            </div>
            <div>
              <p className="vdp-delete-modal__card-name">{label}</p>
              <p className="vdp-delete-modal__card-sub">
                {isVoucher ? item.discount : item.discount}
                {' • '}expires {item.validity.split(' - ')[1]?.replace(/(\d+)\/(\d+)\/(\d+)/, (_, d, m, y) => `${d} ${['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][+m-1]} ${y}`)}
              </p>
            </div>
            <span className={`voucher-status ${item.status}`}>• {item.status.charAt(0).toUpperCase() + item.status.slice(1)}</span>
          </div>

          <ul className="vdp-delete-modal__consequences">
            <li>The voucher code will stop working immediately.</li>
            <li>All usage history will be permanently erased</li>
            <li>Customers with this code can no longer redeem it</li>
          </ul>
        </div>

        <div className="vdp-delete-modal__footer">
          <button className="vdp-delete-modal__cancel" onClick={onClose}>Cancel</button>
          <button className="vdp-delete-modal__confirm" onClick={() => { onConfirm(); onClose() }}>
            <Trash size={16} weight="fill" />
            Delete {isVoucher ? 'voucher' : 'promo code'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}

// ─── Outlet Applicability Tab ─────────────────────────────────────────────────

function OutletApplicabilityTab({ item }) {
  const included = OUTLETS.filter((o) => !o.excluded)
  return (
    <div className="vdp-outlet-tab">
      <p className="vdp-outlet-tab__count">{included.length} of {OUTLETS.length} outlets selected</p>
      <div className="vdp-outlet-list">
        {OUTLETS.map((outlet) => (
          <div key={outlet.id} className={`vdp-outlet-row ${outlet.excluded ? 'vdp-outlet-row--excluded' : ''}`}>
            <div>
              <p className="vdp-outlet-row__name">{outlet.name}</p>
              <p className="vdp-outlet-row__address">{outlet.address}</p>
            </div>
            {outlet.excluded
              ? <span className="vdp-outlet-row__not-included">Not included</span>
              : <span className="vdp-outlet-row__redeemed">{outlet.redeemed} redeemed</span>
            }
          </div>
        ))}
      </div>
    </div>
  )
}

// ─── Details Tab (editable form) ─────────────────────────────────────────────

const OUTLETS_LIST = [
  'Sunway Outlet',
  'KLCC Outlet',
  'TRX Outlet',
  'Mid Valley Outlet',
  'Pavilion Outlet',
]

const ORDER_TYPES = ['Dine-in', 'Pickup', 'Kiosk']

function DetailsTab({ item, kind }) {
  const isVoucher = kind === 'voucher'

  // ── Discount section ──
  const [discountType, setDiscountType] = useState('percent') // 'percent' | 'fixed'
  const [discountPct,  setDiscountPct]  = useState(item.type === 'percent' ? item.discount.replace(/[^0-9]/g,'') : '')
  const [discountAmt,  setDiscountAmt]  = useState(item.type === 'cash'    ? item.discount.replace(/[^0-9]/g,'') : '')
  const [discountCap,  setDiscountCap]  = useState('')
  const [points,       setPoints]       = useState(item.pointsNum ?? '')
  const [terms,        setTerms]        = useState('')

  // ── Scope & usage ──
  const [scope,          setScope]          = useState('merchant') // 'merchant' | 'outlet'
  const [selectedOutlets,setSelectedOutlets] = useState([])
  const [claimLimit,     setClaimLimit]     = useState(item.total ?? '')
  const [usageLimit,     setUsageLimit]     = useState('')
  const [minSpend,       setMinSpend]       = useState(item.minimum.replace(/[^0-9.]/g,''))
  const [orderTypes,     setOrderTypes]     = useState(['Dine-in'])
  const [validFrom,      setValidFrom]      = useState('')
  const [validFromOn,    setValidFromOn]    = useState(false)
  const [validUntil,     setValidUntil]     = useState('')
  const [validUntilOn,   setValidUntilOn]   = useState(false)

  const toggleOrderType = (t) =>
    setOrderTypes((prev) =>
      prev.includes(t) ? prev.filter((x) => x !== t) : [...prev, t]
    )

  const toggleOutlet = (o) =>
    setSelectedOutlets((prev) =>
      prev.includes(o) ? prev.filter((x) => x !== o) : [...prev, o]
    )

  return (
    <div className="vdp-edit-form">

      {/* ── DISCOUNT TYPE ── */}
      <div className="vdp-form-section">
        <p className="vdp-form-section__title">Discount type</p>
        <div className="vdp-radio-cards">
          <label className={`vdp-radio-card ${discountType === 'percent' ? 'vdp-radio-card--active' : ''}`}>
            <input type="radio" name="discountType" value="percent" checked={discountType === 'percent'} onChange={() => setDiscountType('percent')} />
            <span className="vdp-radio-card__indicator" />
            <div>
              <strong>Percentage off</strong>
              <p>A % discount on the order subtotal. E.g. 10% off.</p>
            </div>
          </label>
          <label className={`vdp-radio-card ${discountType === 'fixed' ? 'vdp-radio-card--active' : ''}`}>
            <input type="radio" name="discountType" value="fixed" checked={discountType === 'fixed'} onChange={() => setDiscountType('fixed')} />
            <span className="vdp-radio-card__indicator" />
            <div>
              <strong>Fixed amount off</strong>
              <p>A fixed RM value deducted from the order total.</p>
            </div>
          </label>
        </div>
      </div>

      {/* ── DISCOUNT FIELDS ── */}
      <div className="vdp-form-row">
        <div className="vdp-form-field">
          <label>{discountType === 'percent' ? 'Discount percentage' : 'Discount amount'}</label>
          <div className="vdp-input-suffix">
            <input
              type="number"
              min="0"
              value={discountType === 'percent' ? discountPct : discountAmt}
              onChange={(e) => discountType === 'percent' ? setDiscountPct(e.target.value) : setDiscountAmt(e.target.value)}
            />
            <span className="vdp-input-suffix__tag">{discountType === 'percent' ? '%' : 'RM'}</span>
          </div>
          <p className="vdp-form-hint">Applied to order subtotal before tax</p>
        </div>

        <div className="vdp-form-field">
          <label>Max discount cap <span className="vdp-form-optional">optional</span></label>
          <div className="vdp-input-prefix">
            <span className="vdp-input-prefix__tag">RM</span>
            <input type="number" min="0" placeholder="No cap" value={discountCap} onChange={(e) => setDiscountCap(e.target.value)} />
          </div>
          <p className="vdp-form-hint">Limits the max RM saved per redemption</p>
        </div>
      </div>

      {/* ── POINTS (voucher only) ── */}
      {isVoucher && (
        <div className="vdp-form-field">
          <label>Points required</label>
          <input type="number" min="0" value={points} onChange={(e) => setPoints(e.target.value)} />
          <p className="vdp-form-hint">Define the number of loyalty points needed to redeem the voucher</p>
        </div>
      )}

      {/* ── TERMS ── */}
      <div className="vdp-form-field">
        <label>Terms and conditions <span className="vdp-form-optional">(if applicable)</span></label>
        <textarea rows={5} value={terms} onChange={(e) => setTerms(e.target.value)} placeholder="E.g. Not valid with other promotions." />
      </div>

      {/* ── SCOPE & USAGE RULES ── */}
      <div className="vdp-form-section">
        <p className="vdp-form-section__title">Scope &amp; usage rules</p>

        <div className="vdp-form-field">
          <label>Scope</label>
          <div className="vdp-radio-cards">
            <label className={`vdp-radio-card ${scope === 'merchant' ? 'vdp-radio-card--active' : ''}`}>
              <input type="radio" name="scope" value="merchant" checked={scope === 'merchant'} onChange={() => setScope('merchant')} />
              <span className="vdp-radio-card__indicator" />
              <div>
                <strong>Merchant-wide</strong>
                <p>Available at all outlets. Customers at any branch can redeem this reward.</p>
              </div>
            </label>
            <label className={`vdp-radio-card ${scope === 'outlet' ? 'vdp-radio-card--active' : ''}`}>
              <input type="radio" name="scope" value="outlet" checked={scope === 'outlet'} onChange={() => setScope('outlet')} />
              <span className="vdp-radio-card__indicator" />
              <div>
                <strong>Outlet specific</strong>
                <p>Available only at selected outlets.</p>
              </div>
            </label>
          </div>

          {/* Outlet chips — shown when outlet specific */}
          {scope === 'outlet' && (
            <div className="vdp-outlet-chips-wrap">
              <p className="vdp-form-field__sublabel">Select outlets</p>
              <div className="vdp-chips">
                {OUTLETS_LIST.map((o) => (
                  <button
                    key={o}
                    type="button"
                    className={`vdp-chip ${selectedOutlets.includes(o) ? 'vdp-chip--active' : ''}`}
                    onClick={() => toggleOutlet(o)}
                  >
                    {o}
                  </button>
                ))}
              </div>
              <p className="vdp-form-hint">Customers can redeem this voucher only at selected outlets.</p>
            </div>
          )}
        </div>

        {/* Claim & usage limits */}
        <div className="vdp-form-row">
          <div className="vdp-form-field">
            <label>Total claim limit</label>
            <input type="number" min="0" placeholder="Unlimited" value={claimLimit} onChange={(e) => setClaimLimit(e.target.value)} />
            <p className="vdp-form-hint">Leave blank for no limit</p>
          </div>
          <div className="vdp-form-field">
            <label>Usage limit per customer</label>
            <input type="number" min="0" placeholder="Unlimited" value={usageLimit} onChange={(e) => setUsageLimit(e.target.value)} />
            <p className="vdp-form-hint">Leave blank for no limit</p>
          </div>
        </div>

        {/* Min spend + order types */}
        <div className="vdp-form-row">
          <div className="vdp-form-field">
            <label>Minimum order spend</label>
            <div className="vdp-input-prefix">
              <span className="vdp-input-prefix__tag">RM</span>
              <input type="number" min="0" placeholder="None" value={minSpend} onChange={(e) => setMinSpend(e.target.value)} />
            </div>
            <p className="vdp-form-hint">Limits the max RM saved per redemption</p>
          </div>
          <div className="vdp-form-field">
            <label>Valid for order types</label>
            <div className="vdp-chips">
              {ORDER_TYPES.map((t) => (
                <button
                  key={t}
                  type="button"
                  className={`vdp-chip ${orderTypes.includes(t) ? 'vdp-chip--active' : ''}`}
                  onClick={() => toggleOrderType(t)}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Validity dates */}
        <div className="vdp-form-row">
          <div className="vdp-form-field">
            <div className="vdp-form-field__label-row">
              <label>Valid from</label>
              <label className="vdp-checkbox">
                <input type="checkbox" checked={validFromOn} onChange={(e) => setValidFromOn(e.target.checked)} />
                <span>Enable</span>
              </label>
            </div>
            <input type="date" value={validFrom} onChange={(e) => setValidFrom(e.target.value)} disabled={!validFromOn} placeholder="dd/mm/yyyy" />
            <p className="vdp-form-hint">No start date restriction</p>
          </div>
          <div className="vdp-form-field">
            <div className="vdp-form-field__label-row">
              <label>Valid until</label>
              <label className="vdp-checkbox">
                <input type="checkbox" checked={validUntilOn} onChange={(e) => setValidUntilOn(e.target.checked)} />
                <span>Enable</span>
              </label>
            </div>
            <input type="date" value={validUntil} onChange={(e) => setValidUntil(e.target.value)} disabled={!validUntilOn} placeholder="dd/mm/yyyy" />
            <p className="vdp-form-hint">Leave blank for no expiry</p>
          </div>
        </div>
      </div>

      {/* ── SAVE ── */}
      <div className="vdp-form-actions">
        <button className="vdp-form-actions__save">Save changes</button>
      </div>

    </div>
  )
}

// ─── Details Panel ────────────────────────────────────────────────────────────

function VoucherDetailsPanel({ item, kind, onClose, onDelete, onToggleStatus }) {
  const [activeTab, setActiveTab] = useState('applicability')
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const isVoucher  = kind === 'voucher'
  const isActive   = item.status === 'active'
  const claimed    = isVoucher ? item.claimed   : item.redeemed
  const total      = item.total
  const left       = item.left
  const pct        = Math.round((claimed / total) * 100)

  return (
    <>
      <div className="vdp-overlay" onClick={onClose} />

      <aside className="vdp-panel">
        {/* Top bar */}
        <div className="vdp-panel__topbar">
          <span>Voucher details</span>
          <button onClick={onClose}><X size={18} /></button>
        </div>

        {/* Hero */}
        <div className="vdp-panel__hero">
          <div>
            <p className="vdp-panel__hero-kind">{isVoucher ? 'Reward Voucher' : 'Promo code'}</p>
            <h2 className="vdp-panel__hero-title">{isVoucher ? item.title : item.code}</h2>
          </div>
          <div className="vdp-panel__hero-badges">
            <span className="vdp-badge vdp-badge--discount">• {item.discount || item.discountBadge}</span>
            <span className={`voucher-status ${item.status}`}>• {item.status.charAt(0).toUpperCase() + item.status.slice(1)}</span>
          </div>
        </div>

        {/* Scrollable body */}
        <div className="vdp-panel__body">
          {/* Meta rows */}
          <div className="vdp-meta">
            {isVoucher ? (
              <>
                <div className="vdp-meta__row"><span>Voucher name:</span><strong>{item.voucherName}</strong></div>
                <div className="vdp-meta__row"><span>Points required:</span><strong>{item.pointsNum} pts</strong></div>
              </>
            ) : (
              <div className="vdp-meta__row"><span>Discount:</span><strong>{item.discount}</strong></div>
            )}
            <div className="vdp-meta__row"><span>Promo code:</span><strong>{!isVoucher ? item.code : '–'}</strong></div>
            <div className="vdp-meta__row"><span>Scope:</span><strong>{item.scope}</strong></div>
            <div className="vdp-meta__row">
              <span>Validity:</span>
              <strong>{item.validityLong}</strong>
              {item.daysRemaining > 0 && (
                <span className="vdp-meta__remaining">
                  <Clock size={14} /> {item.daysRemaining} days remaining
                </span>
              )}
            </div>
          </div>

          {/* Stats card */}
          <p className="vdp-section-label">FOR ALL TIME</p>
          <div className="vdp-stats-card">
            <div className="vdp-stats-card__row">
              <div>
                <span>USAGE LIMIT</span>
                <strong>{claimed} <span className="vdp-stats-card__of">/{total}</span></strong>
              </div>
              <div>
                <span>REVENUE</span>
                <strong>{item.revenue}</strong>
              </div>
            </div>
            <div className="voucher-progress">
              <div className="voucher-progress__bar" style={{ width: `${pct}%` }} />
            </div>
            <div className="voucher-progress__footer">
              <span>{claimed}/{total} claimed</span>
              <span>{left} remaining</span>
            </div>
          </div>

          {/* Tabs */}
          <div className="vdp-tabs">
            <button
              className={`vdp-tab ${activeTab === 'applicability' ? 'vdp-tab--active' : ''}`}
              onClick={() => setActiveTab('applicability')}
            >
              Outlet Applicability
            </button>
            <button
              className={`vdp-tab ${activeTab === 'details' ? 'vdp-tab--active' : ''}`}
              onClick={() => setActiveTab('details')}
            >
              Details
            </button>
          </div>

          {activeTab === 'applicability' && <OutletApplicabilityTab item={item} />}
          {activeTab === 'details'       && <DetailsTab item={item} kind={kind} />}
        </div>

        {/* Footer — activate/deactivate LEFT · delete RIGHT */}
        <div className="vdp-panel__footer">
          <button
            className={`vdp-footer-toggle ${isActive ? 'vdp-footer-toggle--deactivate' : 'vdp-footer-toggle--activate'}`}
            onClick={onToggleStatus}
          >
            {isActive
              ? <><ProhibitInset size={16} /> Deactivate</>
              : <><CheckCircle size={16} weight="fill" /> Activate</>
            }
          </button>

          <button
            className="vdp-footer-delete"
            onClick={() => setShowDeleteModal(true)}
          >
            Delete {isVoucher ? 'voucher' : 'promo code'}
          </button>
        </div>
      </aside>

      {showDeleteModal && (
        <DeleteModal
          item={item}
          kind={kind}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={() => { onDelete(); onClose() }}
        />
      )}
    </>
  )
}

// ─── Voucher card ─────────────────────────────────────────────────────────────

function VoucherCard({ item, kind, onClick }) {
  const isVoucher = kind === 'voucher'
  const claimed   = isVoucher ? item.claimed : item.redeemed
  return (
    <div className="voucher-card" onClick={onClick} style={{ cursor: 'pointer' }}>
      <div className="voucher-card__top">
        <div className="voucher-card__icon">
          {item.type === 'percent' ? <Percent size={24} /> : <CurrencyDollar size={24} />}
        </div>
        <div className={`voucher-status ${item.status}`}>• {item.status.charAt(0).toUpperCase() + item.status.slice(1)}</div>
      </div>

      <h3>{isVoucher ? item.title : item.code}</h3>

      <div className="voucher-meta">
        {isVoucher ? (
          <><span>{item.points}</span><span>•</span><span>{item.minimum}</span><span>•</span><span>{item.validity}</span></>
        ) : (
          <><span>{item.discount}</span><span>•</span><span>{item.minimum}</span><span>•</span><span>{item.validity}</span></>
        )}
      </div>

      <div className="voucher-progress">
        <div className="voucher-progress__bar" style={{ width: `${Math.round((claimed / item.total) * 100)}%` }} />
      </div>

      <div className="voucher-progress__footer">
        <span>{claimed}/{item.total} claimed</span>
        <span>{item.left} left</span>
      </div>
    </div>
  )
}

// ─── Main Page ────────────────────────────────────────────────────────────────

export default function VouchersPage() {
  const [activeTab, setActiveTab] = useState('reward')
  const [selectedItem, setSelectedItem] = useState(null)
  const [selectedKind, setSelectedKind] = useState(null)

  // Local status toggle (in-memory)
  const [voucherStatuses, setVoucherStatuses]   = useState({})
  const [promoStatuses,   setPromoStatuses]     = useState({})

  const getStatus = (item, kind) => {
    const map = kind === 'voucher' ? voucherStatuses : promoStatuses
    return map[item.id] ?? item.status
  }

  const toggleStatus = (item, kind) => {
    const setter = kind === 'voucher' ? setVoucherStatuses : setPromoStatuses
    setter((prev) => ({
      ...prev,
      [item.id]: prev[item.id] === 'inactive' ? 'active'
        : (prev[item.id] ?? item.status) === 'active' ? 'inactive' : 'active',
    }))
  }

  const openPanel = (item, kind) => {
    setSelectedItem({ ...item, status: getStatus(item, kind) })
    setSelectedKind(kind)
  }

  return (
    <div className="vouchers-page">
      <div className="page-header">
        <div>
          <h1>Vouchers</h1>
          <p>Configure reward vouchers redeemed with loyalty points and customer-entered promo codes</p>
        </div>
      </div>

      {/* Hero cards */}
      <div className="voucher-hero">
        <div className="voucher-hero__card reward">
          <div className="voucher-hero__top">
            <div className="voucher-hero__icon reward"><Ticket size={28} /></div>
            <div>
              <h3>Reward vouchers</h3>
              <p>Redeemed with loyalty points — no code needed</p>
            </div>
          </div>
          <div className="voucher-hero__description">
            Customers tap to claim from their loyalty wallet using earned points. Two discount types: % off subtotal or fixed RM off total.
          </div>
          <Link to="/vouchers/create-reward" className="voucher-overview-card__button">
            <Plus size={20} weight="bold" /><span>Create Reward</span>
          </Link>
        </div>

        <div className="voucher-hero__card promo">
          <div className="voucher-hero__top">
            <div className="voucher-hero__icon promo"><Lock size={28} /></div>
            <div>
              <h3>Promo codes</h3>
              <p>Customers type at checkout — no points needed</p>
            </div>
          </div>
          <div className="voucher-hero__description">
            Customers manually enter an alphanumeric code (e.g. SAKURA10) in the promo field at checkout.
          </div>
          <Link to="/vouchers/create-promo" className="voucher-overview-card__button voucher-overview-card__button--purple">
            <Plus size={20} weight="bold" /><span>Create Promo Code</span>
          </Link>
        </div>
      </div>

      {/* Tabs */}
      <div className="voucher-tabs">
        <button className={activeTab === 'reward' ? 'active' : ''} onClick={() => setActiveTab('reward')}>
          Reward vouchers (8)
        </button>
        <button className={activeTab === 'promo' ? 'active' : ''} onClick={() => setActiveTab('promo')}>
          Promo codes (6)
        </button>
      </div>

      {/* Reward tab */}
      {activeTab === 'reward' && (
        <>
          <div className="voucher-stats">
            <div className="stat-card"><span>ACTIVE VOUCHERS</span><h3>8</h3><p>across 5 outlets</p></div>
            <div className="stat-card"><span>REDEEMED THIS MONTH</span><h3>38</h3><p className="positive">↑ 14 vs last month</p></div>
            <div className="stat-card"><span>POINTS SPENT</span><h3>9,500 pts</h3></div>
          </div>
          <div className="voucher-section-title">MERCHANT-WIDE</div>
          <div className="voucher-grid">
            {vouchers.map((v) => (
              <VoucherCard
                key={v.id}
                item={{ ...v, status: getStatus(v, 'voucher') }}
                kind="voucher"
                onClick={() => openPanel(v, 'voucher')}
              />
            ))}
          </div>
          <div className="table-pagination">
            <div>Showing 1 - 10 of 79 results</div>
            <div className="pagination">
              <button>{'<'}</button>
              <button className="active">1</button>
              <button>2</button><button>3</button><button>4</button><button>5</button><button>8</button>
              <button>{'>'}</button>
            </div>
          </div>
        </>
      )}

      {/* Promo tab */}
      {activeTab === 'promo' && (
        <>
          <div className="voucher-stats">
            <div className="stat-card"><span>ACTIVE PROMO CODE</span><h3>8</h3><p>across 5 outlets</p></div>
            <div className="stat-card"><span>REDEEMED THIS MONTH</span><h3>38</h3><p className="positive">↑ 14 vs last month</p></div>
          </div>
          <div className="voucher-section-title">MERCHANT-WIDE</div>
          <div className="voucher-grid">
            {promoCodes.map((p) => (
              <VoucherCard
                key={p.id}
                item={{ ...p, status: getStatus(p, 'promo') }}
                kind="promo"
                onClick={() => openPanel(p, 'promo')}
              />
            ))}
          </div>
          <div className="table-pagination">
            <div>Showing 1 - 10 of 79 results</div>
            <div className="pagination">
              <button>{'<'}</button>
              <button className="active">1</button>
              <button>2</button><button>3</button><button>4</button><button>5</button><button>8</button>
              <button>{'>'}</button>
            </div>
          </div>
        </>
      )}

      {/* Details panel */}
      {selectedItem && selectedKind && (
        <VoucherDetailsPanel
          item={selectedItem}
          kind={selectedKind}
          onClose={() => setSelectedItem(null)}
          onDelete={() => setSelectedItem(null)}
          onToggleStatus={() => {
            toggleStatus(selectedItem, selectedKind)
            setSelectedItem((prev) => ({
              ...prev,
              status: prev.status === 'active' ? 'inactive' : 'active',
            }))
          }}
        />
      )}
    </div>
  )
}